import { DatePipe } from '@angular/common';
import { DateTime } from 'luxon';

export function getDate(date : string | null) : string {
    if (date){
        //parse the input date to string
        return DateTime.fromISO(date).toFormat("dd/MM/yyyy");
    }
    //Fallback to the current date
    return DateTime.now().toFormat("dd/MM/yyyy");
}

export function getTime(date: string | null): string {
    if (date) {
          //parse the input date to string
        return DateTime.fromISO(date, {zone: "America/New_York"}).toFormat("hh:mm a");
    }
    //Fallback to the current date
    return DateTime.now().setZone( "America/New_York" ).toFormat("hh:mm a");
}


export function getDateTime(requestedDate: string | null): { date: string; time: string } {
    return {
        date : getDate(requestedDate),
        time : getTime(requestedDate)
    };
}

export function getTradeDate(): string {
    return DateTime.local({ zone: "America/New_York" }).toString();
}

export function convertDate(date: string){
    const [day, month, year] = date.split('/');
    const dateObj =  new Date([year, month, day].toString());
    const datePipe = new DatePipe('en-US');
   
    return datePipe.transform(dateObj, 'MM/dd/yyyy');
}

export function convertUTCToEasternTime24(date: string | null | undefined): string {
    if (!date) {
        return '';
    }
    
    const dateObj = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'America/New_York'
    };
    return dateObj.toLocaleString('en-US', options).replace(',', '');
}

export function getEasternTimeWithEtSuffix(date: string | null): string {
    const dt = date
        ? DateTime.fromISO(date, { zone: "America/New_York" })
        : DateTime.now().setZone("America/New_York");
    return dt.toFormat("h:mm a").toLowerCase() + " ET";
}

/**
 * Extracts the date portion (YYYY-MM-DD) from an ISO date string and formats it as 'MM/dd/yyyy'.
 * Ignores any time or timezone information in the input string.
 *
 * @param date - An ISO date string (e.g., '2025-04-10T00:00:00Z').
 * @returns The formatted date string in 'MM/dd/yyyy' format (e.g., '04/10/2025').
 *
 * @example
 * getDateWOTimezone('2025-04-10T00:00:00Z'); // Returns '04/10/2025'
 */
export function getDateWOTimezone(date: string) {
    // Extract only the date part (YYYY-MM-DD) from the string
    const datePart = date.split('T')[0];
    // Use Luxon to format as MM/dd/yyyy
    return DateTime.fromISO(datePart).toFormat('MM/dd/yyyy');
}